<script>
    export default {
        data() {
            return {
                filterMutable: this.filter,
                url: '',
                id: null,
                can: null,
                productName: null,
                productQuantity: null,
                productSize: null,
                productColor: null,
                country: null,
                vendor: null,
                supplierProductNr: null,
                notSupplierProductNr: null,
                emptySupplierProductNr: null,
                filledSupplierProductNr: null,
                bnr: null,
                notBnr: null,
                emptyBnr: null,
                filledBnr: null,
                storagePlace: null,
                notStoragePlace: null,
                emptyStoragePlace: null,
                filledStoragePlace: null,
                storageArea: null,
                notStorageArea: null,
                emptyStorageArea: null,
                filledStorageArea: null,
                comment: null,
                productReceiptDate: null,
                notProductReceiptDate: null,
                emptyProductReceiptDate: null,
                filledProductReceiptDate: null,
                productIssueDate: null,
                notProductIssueDate: null,
                emptyProductIssueDate: null,
                filledProductIssueDate: null
            }
        },
        mounted() {
            window.formElementRelations.inputsRegistered();
            this.url = new URI(window.location.href);
        },
        props: {
            filter: {},
            countryList: null,
            storageAreaList: null
        },
        methods: {
            search() {
                _.each(this.filterMutable, (value, key) => {
                    this.url.removeQuery(key);
                    if (value && key != 'reset') {
                        this.url.addQuery(key, value);
                    }
                });

                window.location.href = this.url.toString();
            },
            reset() {
                _.each(this.filterMutable, (value, key) => {
                    this.url.removeQuery(key);
                    this.url.removeQuery('reset');
                });

                window.location.href = this.url.toString() + '?reset=true';
            }
        }
    }
</script>

<template>
    <div>
        <div class="row">
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Muster ID</h5>
                </label>
                <input type="number" class="form-control full-width" v-model="filterMutable.id" @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>CAN</h5>
                </label>
                <input type="number" class="form-control full-width" v-model="filterMutable.can" @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Name</h5>
                </label>
                <input type="text" class="form-control full-width" v-model="filterMutable.productName"
                       @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Menge</h5>
                </label>
                <input type="text" class="form-control full-width" v-model="filterMutable.productQuantity"
                       @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Größe</h5>
                </label>
                <input type="text" class="form-control full-width" v-model="filterMutable.productSize"
                       @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Farbe</h5>
                </label>
                <input type="text" class="form-control full-width" v-model="filterMutable.productColor"
                       @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Country</h5>
                </label>
                <v-select :options="countryList" v-model="filterMutable.country"></v-select>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Vendor</h5>
                </label>
                <input type="text" class="form-control full-width" v-model="filterMutable.vendor" @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Lieferanten Artikelnummer</h5>
                </label>
                <div class="input-group">
                    <div>
                        <input type="text" class="form-control full-width" v-model="filterMutable.supplierProductNr" @keyup.enter="search">
                    </div>
                    <div class="input-group-addon p-w-m">
                        <button data-toggle="dropdown" class="btn btn-xs dropdown-toggle p-w-m" type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right">
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.notSupplierProductNr" /> nicht</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.emptySupplierProductNr" /> leer</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.filledSupplierProductNr" /> befüllt</label></li>
                        </ul>
                    </div>
                    <div class="input-group-addon" v-if="filterMutable.notSupplierProductNr || filterMutable.emptySupplierProductNr || filterMutable.filledSupplierProductNr">
                        <span class="label label-primary"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>BNR</h5>
                </label>
                <div class="input-group">
                    <div>
                        <input type="text" class="form-control full-width" v-model="filterMutable.bnr" @keyup.enter="search">
                    </div>
                    <div class="input-group-addon p-w-m">
                        <button data-toggle="dropdown" class="btn btn-xs dropdown-toggle p-w-m" type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right">
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.notBnr" /> nicht</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.emptyBnr" /> leer</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.filledBnr" /> befüllt</label></li>
                        </ul>
                    </div>
                    <div class="input-group-addon" v-if="filterMutable.notBnr || filterMutable.emptyBnr || filterMutable.filledBnr">
                        <span class="label label-primary"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Lagerplatz</h5>
                </label>
                <div class="input-group">
                    <div>
                        <input type="text" class="form-control full-width" v-model="filterMutable.storagePlace" @keyup.enter="search">
                    </div>
                    <div class="input-group-addon p-w-m">
                        <button data-toggle="dropdown" class="btn btn-xs dropdown-toggle p-w-m" type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right">
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.notStoragePlace" /> nicht</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.emptyStoragePlace" /> leer</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.filledStoragePlace" /> befüllt</label></li>
                        </ul>
                    </div>
                    <div class="input-group-addon" v-if="filterMutable.notStoragePlace || filterMutable.emptyStoragePlace || filterMutable.filledStoragePlace">
                        <span class="label label-primary"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Ort</h5>
                </label>
                <div class="input-group">
                    <div><v-select :options="storageAreaList" v-model="filterMutable.storageArea"></v-select></div>
                    <div class="input-group-addon p-w-m">
                        <button data-toggle="dropdown" class="btn btn-xs dropdown-toggle p-w-m" type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right">
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.notStorageArea" /> nicht</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.emptyStorageArea" /> leer</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.filledStorageArea" /> befüllt</label></li>
                        </ul>
                    </div>
                    <div class="input-group-addon" v-if="filterMutable.notStorageArea || filterMutable.emptyStorageArea || filterMutable.filledStorageArea">
                        <span class="label label-primary"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Kommentar</h5>
                </label>
                <input type="text" class="form-control full-width" v-model="filterMutable.comment"
                       @keyup.enter="search">
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Wareneingang</h5>
                </label>
                <div class="input-group">
                    <div>
                        <input type="date" class="form-control full-width" v-model="filterMutable.productReceiptDate" @keyup.enter="search">
                    </div>
                    <div class="input-group-addon p-w-m">
                        <button data-toggle="dropdown" class="btn btn-xs dropdown-toggle p-w-m" type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right">
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.notProductReceiptDate" /> nicht</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.emptyProductReceiptDate" /> leer</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.filledProductReceiptDate" /> befüllt</label></li>
                        </ul>
                    </div>
                    <div class="input-group-addon" v-if="filterMutable.notProductReceiptDate || filterMutable.emptyProductReceiptDate || filterMutable.filledProductReceiptDate">
                        <span class="label label-primary"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm">
                <label class="block">
                    <h5>Warenausgang</h5>
                </label>
                <div class="input-group">
                    <div>
                        <input type="date" class="form-control full-width" v-model="filterMutable.productIssueDate" @keyup.enter="search">
                    </div>
                    <div class="input-group-addon p-w-m">
                        <button data-toggle="dropdown" class="btn btn-xs dropdown-toggle p-w-m" type="button" aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right">
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.notProductIssueDate" /> nicht</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.emptyProductIssueDate" /> leer</label></li>
                            <li><label style="padding: 5px;"><input type="checkbox" v-model="filterMutable.filledProductIssueDate" /> befüllt</label></li>
                        </ul>
                    </div>
                    <div class="input-group-addon" v-if="filterMutable.notProductIssueDate || filterMutable.emptyProductIssueDate || filterMutable.filledProductIssueDate">
                        <span class="label label-primary"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 m-b-sm text-center pull-right">
                <h5></h5>
                <div class="btn-group btn-group-justified col-md-12" role="group">
                    <div class="btn-group" role="group">
                        <div class="btn btn-white btn-sm" @click="reset()">
                            <span class="m-r-sm">Zurücksetzen</span>
                            <i class="fa fa-trash"></i>
                        </div>
                    </div>
                    <div class="btn-group" role="group">
                        <div class="btn btn-primary btn-sm" @click="search()">
                            <span class="m-r-sm">Anwenden</span>
                            <i class="fa fa-filter"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
